export const CLASS_NAMES = {
  wrapper: "flex flex-row mt-6 mr-auto",
};
